import React from "react";
import "../MenuLeftProveedorComercializador/menuLeftProv.css";
//
import logoAmebo from "../../../assets/logo/logo2.png";
//
import { MdOutlineAttachMoney } from "react-icons/md";
import { FaFileArchive, FaArchive, FaUserAlt, FaUserCog } from "react-icons/fa";
import { FaDeleteLeft, FaUserTie } from "react-icons/fa6";
import { RiLockPasswordFill } from "react-icons/ri";
import { ImProfile } from "react-icons/im";
import { LuClipboardList } from "react-icons/lu";
import { Link } from "react-router-dom";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";

const MenuLeftAdmin = ({ viewSee }) => {
  const navigate = useNavigate();

  const changeviewprov = (e, page) => {
    e.preventDefault();
    viewSee(page);
  };

  const handleLogout = () => {
    Cookies.remove("token");
    Cookies.remove("adminType");
    sessionStorage.removeItem("Data");
    navigate("/");
  };

  return (
    <div className="allmenuleft">
      <div className="boxlogoprov">
        <img className="logomenuleftprov" src={logoAmebo} alt="logo" />
      </div>
      <div className="boxallbuttonprov">
        <Link to="/portal-admin-proveedor/todas-las-ventas">
          <div className="boxbuttonprov">
            <p className="letterbuttonprov">
              <MdOutlineAttachMoney className="iconprov" />
              Ventas
            </p>
          </div>
        </Link>

        <Link to="/portal-admin-proveedor/lista-comercializadores">
          <div className="boxbuttonprov">
            <p className="letterbuttonprov">
              <FaUserCog className="iconprov" />
              Comercializadores
            </p>
          </div>
        </Link>

        <Link to="/portal-admin-proveedor/lista-proveedores">
          <div className="boxbuttonprov">
            <p className="letterbuttonprov">
              <FaUserCog className="iconprov" />
              Proveedores
            </p>
          </div>
        </Link>

        <div
          className="boxbuttonprov"
          onClick={(e) => changeviewprov(e, "Perfil")}
        >
          <p className="letterbuttonprov">
            <FaUserAlt className="iconprov" />
            Perfil
          </p>
        </div>
        <div
          className="boxbuttonprov"
          onClick={(e) => changeviewprov(e, "ExcelComer")}
        >
          <p className="letterbuttonprov">
            <ImProfile className="iconprov" />
            Alta comercializador
          </p>
        </div>
        <div
          className="boxbuttonprov"
          onClick={(e) => changeviewprov(e, "ExcelProv")}
        >
          <p className="letterbuttonprov">
            <FaUserTie className="iconprov" />
            Alta proveedores
          </p>
        </div>
        <div
          className="boxbuttonprov"
          onClick={(e) => changeviewprov(e, "ExcelSales")}
        >
          <p className="letterbuttonprov">
            <FaFileArchive className="iconprov" />
            Alta ventas
          </p>
        </div>
        <div
          className="boxbuttonprov"
          onClick={(e) => changeviewprov(e, "ListProveedordescarga")}
        >
          <p className="letterbuttonprov">
            <LuClipboardList className="iconprov" />
            Descargar ventas
          </p>
        </div>
        <div
          className="boxbuttonprov"
          onClick={(e) => changeviewprov(e, "Reports")}
        >
          <p className="letterbuttonprov">
            <LuClipboardList className="iconprov" />
            Reporte Anual
          </p>
        </div>
        <div
          className="boxbuttonprov"
          onClick={(e) => changeviewprov(e, "xmldowload")}
        >
          <p className="letterbuttonprov">
            <FaArchive className="iconprov" />
            Descarga proveedor
          </p>
        </div>
        <div
          className="boxbuttonprov"
          onClick={(e) => changeviewprov(e, "Contraseña")}
        >
          <p className="letterbuttonprov">
            <RiLockPasswordFill className="iconprov" />
            Cambiar contraseña
          </p>
        </div>
        <div className="boxbuttonprov" onClick={handleLogout}>
          <p className="letterbuttonprov">
            <FaDeleteLeft className="iconprov" />
            Salir
          </p>
        </div>
      </div>
    </div>
  );
};

export default MenuLeftAdmin;
